export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  author: string;
  date: string;
  readCount: number;
  tags: string[];
  featured: boolean;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '日记系列', slug: 'diary-series' },
  { name: '短篇故事', slug: 'short-stories' },
  { name: '连载小说', slug: 'serial-novels' },
  { name: '热门推荐', slug: 'hot-picks' },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '淫母日记：那个夏天的秘密',
    excerpt: '那是一个闷热的夏天，我无意中发现了母亲藏在衣柜深处的日记本。翻开泛黄的纸页，一段尘封多年的往事逐渐浮出水面，彻底颠覆了我对这个温柔女人的所有认知……',
    content: `<p>那是一个闷热的夏天，蝉鸣声不绝于耳。我独自在家无聊地翻找着东西，无意中在母亲卧室衣柜的最深处，发现了一个被丝巾包裹着的旧日记本。</p>
<p>日记本的封面已经泛黄，边缘微微卷起，散发着一股淡淡的茉莉花香——那是母亲最喜欢的味道。我犹豫了片刻，最终还是按捺不住好奇心，轻轻翻开了第一页。</p>
<p>字迹娟秀而有力，与母亲平日温婉的形象有些不同。第一篇日记写于二十年前，那时的母亲还只是一个二十出头的姑娘。</p>
<p>"今天他约我去河边散步，夕阳把水面染成了金色。他说喜欢我的头发在风里飘起来的样子。我的心跳得好快，快到我以为它会从喉咙里蹦出来。"</p>
<p>读着这些文字，我仿佛看到了一个完全不同的人——一个鲜活、炽热、充满生命力的年轻女子。她不是什么母亲，不是什么妻子，只是一个正在坠入爱河的女孩。</p>
<p>随着日记一页页翻过，我开始逐渐了解母亲的另一面。那些含蓄而又热烈的文字，勾勒出了一段段我从未想过的往事。有些段落让我脸红心跳，有些则让我陷入深深的沉思。</p>
<p>日记的最后几页，字迹变得潦草而急促。母亲写道，她做出了一个改变她一生的决定。至于那个决定是什么，日记在这里戛然而止，仿佛是作者故意留下的悬念。</p>
<p>合上日记本，我发现自己对母亲的感情变得无比复杂。她不再是那个每天做饭、打扫、叮嘱我多穿衣服的普通中年妇女。在我心中，她变成了一个有故事、有秘密、有血有肉的女人。</p>
<p>我不知道是否应该告诉她我看了她的日记，也不知道那个夏天的秘密到底意味着什么。但我知道，从那天起，我看母亲的眼神变了。那是一种掺杂着好奇、敬畏，以及某种难以言说的悸动的复杂目光。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20old%20worn%20leather%20diary%20on%20a%20dark%20wooden%20desk%20with%20soft%20warm%20candlelight%20glow%2C%20mysterious%20and%20intimate%20atmosphere%2C%20dark%20background%20with%20subtle%20shadows%2C%20elegant%20cinematic%20composition%2C%20warm%20amber%20tones&width=800&height=500&seq=article-cover-1&orientation=landscape',
    author: '匿名作者',
    date: '2026-08-10',
    readCount: 12853,
    tags: ['日记', '回忆', '秘密', '夏季'],
    featured: true,
  },
  {
    id: 'article-2',
    title: '隔壁的诱惑：一个已婚女人的自白',
    excerpt: '搬到这个小区已经三年了。每天最期待的时刻，就是傍晚时分站在阳台上，假装不经意地望向隔壁那扇永远半掩着的窗户。我知道这样不对，但我控制不了自己……',
    content: `<p>搬到这个小区已经三年了。说实话，一开始我并不喜欢这里。小区太旧，邻居太吵，停车位永远不够。如果不是因为离孩子学校近，我早就搬走了。</p>
<p>可是慢慢地，有一个理由让我开始期待每一天的到来。</p>
<p>那个理由就住在隔壁栋。我不知道他的名字，甚至没有和他说过一句话。我只知道他每天傍晚六点会准时出现在阳台上，有时候是浇花，有时候是抽烟，更多的时候只是站在那里，望着远方发呆。</p>
<p>他大概三十多岁，身材保持得很好，穿着总是很随意——一件白T恤，一条深色休闲裤。简单，却莫名地吸引人。他的侧脸线条分明，在落日余晖中显得格外好看。</p>
<p>我开始刻意调整自己的作息。每天五点半，我会洗个澡，换上那条最喜欢的碎花裙子，然后端着一杯茶走到阳台上。我会假装在看手机，或者整理晾晒的衣物，实际上余光一直在偷偷瞄向隔壁。</p>
<p>有时候他会转过头来，我们的目光会在空气中短暂相遇。那一瞬间，我的心跳会漏掉一拍。然后我会迅速移开视线，假装什么都没有发生。</p>
<p>我知道这样不对。我是一个已婚女人，有一个还算过得去的丈夫，有一个可爱的孩子。我不应该对另一个男人产生这样的想法。可是有些东西，就像春天的野草一样，你越是想要压制它，它就越是疯长。</p>
<p>昨天傍晚，他对我笑了。那是一个淡淡的、若有若无的微笑。但我知道那不是一个无意的表情——那是给我的，只给我的。</p>
<p>我端着茶杯的手微微颤抖。茶已经凉了，但我的脸颊却在发烫。我感到一种久违的悸动，一种濒临危险边缘的刺激感。它让我害怕，却又让我兴奋。</p>
<p>今晚我又站在了阳台上。隔壁的窗户半掩着，透出暖黄色的灯光。我不知道接下来会发生什么，但我知道，我已经回不了头了。</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20woman%20silhouette%20on%20a%20balcony%20at%20sunset%2C%20warm%20golden%20light%20pouring%20through%20sheer%20curtains%2C%20dreamy%20and%20sensual%20atmosphere%2C%20dark%20cinematic%20photography%20style%2C%20intimate%20mood%20with%20soft%20bokeh&width=800&height=500&seq=article-cover-2&orientation=landscape',
    author: '匿名作者',
    date: '2026-08-08',
    readCount: 9876,
    tags: ['自白', '诱惑', '婚姻', '邻居'],
    featured: true,
  },
  {
    id: 'article-3',
    title: '深夜办公室的秘密情事',
    excerpt: '加班到深夜早已成为常态。只是那天晚上，办公室里只剩下了我和她。当所有的灯都熄灭，只剩下电脑屏幕的微光时，一切开始变得不同……',
    content: `<p>晚上十一点，办公楼里已经空无一人。我揉了揉酸痛的眼睛，想继续写完那份该死的报告。走廊里传来高跟鞋的声音，由远及近。</p>
<p>是她。我们部门新来的实习生，一个刚毕业不久的女孩，有着明亮的眼睛和总是微微上扬的嘴角。</p>
<p>"还在加班啊？"她站在我工位旁边，手里端着两杯咖啡。她穿着一件白色衬衫和黑色包臀裙，在昏暗的灯光下，整个人看起来既职业又迷人。</p>
<p>"快了快了，你先回去吧，这么晚了。"我接过咖啡，指尖不小心碰到了她的手指。那一瞬间，我感觉到一股微弱的电流从指尖蔓延到全身。</p>
<p>她没有走，反而在我旁边的椅子上坐了下来。她说她也还有工作没做完，但其实我们都知道那只是借口。</p>
<p>办公室的空调发出低沉的嗡嗡声，衬托得周围更加安静。我们有一搭没一搭地聊着天，话题从天南地北不知不觉转向了更加私密的方向。</p>
<p>她说她最近刚分手。我说我结婚五年了。她说五年很长。我说是的，很长。</p>
<p>沉默在我们之间蔓延开来，但并不是那种令人尴尬的沉默。相反，那是一种充满张力的、暗流涌动的沉默。空气中仿佛有什么东西在慢慢发酵。</p>
<p>她忽然站起来，走到了窗边。城市的夜景在她身后铺展开来，万家灯火如同地上的星星。她转过身，背靠着玻璃窗，就那么直直地看着我。她的眼神里有种东西，让我喉咙发干。</p>
<p>那一晚发生的事情，像一场美妙却不真实的梦。第二天上班时，我们依旧像往常一样点头打招呼，好像什么都没有发生过。但我知道，每当我们的目光在会议上交汇时，我们都记得那个深夜，记得那间只亮着一盏灯的办公室。</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20empty%20modern%20office%20at%20night%20with%20city%20lights%20visible%20through%20large%20windows%2C%20two%20coffee%20cups%20on%20a%20desk%2C%20mysterious%20and%20romantic%20late%20night%20atmosphere%2C%20dark%20cinematic%20mood&width=800&height=500&seq=article-cover-3&orientation=landscape',
    author: '匿名作者',
    date: '2026-08-06',
    readCount: 7654,
    tags: ['办公室', '加班', '秘密', '都市'],
    featured: false,
  },
  {
    id: 'article-4',
    title: '淫母日记：衣柜里的信',
    excerpt: '整理母亲遗物的时候，我在她衣柜的夹层里发现了一封没有寄出的信。信封已经泛黄，收件人是一个我从未听说过的名字。怀着复杂的心情，我拆开了那封信……',
    content: `<p>母亲去世后的第三周，我终于鼓起勇气开始整理她的遗物。</p>
<p>那是一个灰蒙蒙的午后，空气中弥漫着旧物的味道。父亲坐在客厅里发呆，姐姐在厨房里默默地擦拭着碗碟。只有我一个人待在母亲的卧室里，一件一件地翻看着那些属于她的东西。</p>
<p>在衣柜的最底层，在一个装着旧毛衣的纸箱里，我的手碰到了一个硬硬的东西。那是一个牛皮纸信封，被小心翼翼地夹在两件羊绒衫之间。信封已经泛黄，但保存得很完整，像是被刻意珍藏的宝物。</p>
<p>信封上写着一个名字——"陈远"。一个我从未听说过的名字。没有地址，没有邮编，只有潦草却有力的三个字。</p>
<p>我犹豫了很久。打开一封死者的私人信件，算不算一种亵渎？最终，想要了解母亲另一面的欲望战胜了我的犹豫。我用微微颤抖的手指撕开了信封。</p>
<p>信很长，足足写了五页。字迹时而工整时而潦草，有些地方还能看到晕开的泪痕。我一个字一个字地读着，仿佛能听到母亲的声音在耳边低语。</p>
<p>原来，在嫁给父亲之前，母亲曾经深爱过另一个男人。他们相识于大学校园，相爱了整整四年。但因为家庭的反对和现实的种种阻碍，最终没能走到一起。</p>
<p>"远，我明天就要嫁给别人了。"母亲在信中写道，"我不知道未来的生活会是什么样子，但我知道，我这辈子最快乐的时光，都是和你一起度过的。那些阳光穿过梧桐树叶洒在图书馆长桌上的午后，那些沿着江边一直走到天黑的傍晚，那些躲在实验室里接吻的深夜——它们会永远活在我心里。"</p>
<p>读到这里，我的眼泪止不住地流了下来。不是因为悲伤，而是因为在那一刻，母亲在我心中不再只是一个角色，一个身份，而是变成了一个真实的、有过爱恨、有过遗憾的完整的人。</p>
<p>我把信重新折好，放回了信封里。我没有告诉任何人这封信的存在。有些秘密，是属于母亲一个人的。我能做的，就是帮她继续守护它们。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20old%20yellowed%20envelope%20with%20handwritten%20Chinese%20characters%20on%20a%20vintage%20wooden%20surface%2C%20soft%20window%20light%20casting%20gentle%20shadows%2C%20nostalgic%20and%20sentimental%20mood%2C%20warm%20sepia%20tones%2C%20delicate%20composition&width=800&height=500&seq=article-cover-4&orientation=landscape',
    author: '匿名作者',
    date: '2026-08-04',
    readCount: 15321,
    tags: ['遗物', '信件', '回忆', '爱情'],
    featured: true,
  },
  {
    id: 'article-5',
    title: '健身房里的暧昧时光',
    excerpt: '办健身卡本是为了减掉身上那几斤多余的赘肉，却没想到在跑步机上遇到了他。汗水和荷尔蒙在空气中交织，一段意料之外的暧昧就此展开……',
    content: `<p>三十岁生日过后，我望着镜子里微微凸起的小腹，终于下定决心办了张健身卡。每周三次，雷打不动。起初很痛苦，每次练完都感觉身体像散了架一样。但坚持了一个月后，我开始享受那种大汗淋漓后的畅快感。</p>
<p>他是在我健身第二个月时出现的。那天我正在跑步机上慢跑，他用余光扫了我一眼，然后选择了紧挨着我的那台机器。说实话，第一眼他就引起了我的注意——一米八几的个子，线条分明的肌肉，还有那种运动型男特有的阳光气质。</p>
<p>我们起初只是点头之交。在更衣室门口擦肩而过时说一声"你好"，在器械区排队时互相谦让一下。但渐渐地，我们开始有了更多交流。</p>
<p>有一次我在做深蹲，姿势不太标准。他走过来，很自然地纠正了我的动作。他的手轻轻扶着我的腰，帮我调整重心。那只手有点粗糙，却很温暖，让我的心跳莫名加速。</p>
<p>从那以后，我们成了健身搭子。每次训练时，他会帮我做保护，递毛巾，倒水。有时候在拉伸区，他会帮我压腿。那种若即若离的身体接触，总是让我心猿意马。</p>
<p>我注意到他经常偷偷看我。当我在镜子前做臀推时，当我在垫子上做卷腹时，他的目光总是若有若无地飘过来。我知道我不应该感到高兴——我已经订婚了，戒指就戴在左手的无名指上。但那种被注视、被渴望的感觉，太让人上瘾了。</p>
<p>昨天健完身后，外面下起了大雨。我没有带伞，他说他开车来的，可以送我回家。车里弥漫着他沐浴露的味道，混着一点汗水的咸味。等红灯的时候，他的手从方向盘上移开，轻轻落在了我的膝盖上。</p>
<p>我没有躲开。我只是盯着挡风玻璃上流淌的雨水，感到心脏快要从胸腔里跳出来了。车窗外，城市的霓虹灯在水中扭曲成模糊的光晕，美得像一场不真实的梦境。</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dim%20gym%20with%20mirrors%20reflecting%20warm%20light%2C%20exercise%20equipment%20in%20soft%20focus%2C%20sensual%20and%20intimate%20atmosphere%2C%20dark%20moody%20photography%2C%20warm%20amber%20lighting&width=800&height=500&seq=article-cover-5&orientation=landscape',
    author: '匿名作者',
    date: '2026-08-02',
    readCount: 6342,
    tags: ['健身', '暧昧', '都市', '邂逅'],
    featured: false,
  },
  {
    id: 'article-6',
    title: '淫母日记：闺蜜来访',
    excerpt: '母亲最好的闺蜜李阿姨每年夏天都会来家里住上一周。今年也不例外。只是这一次，我注意到了一些以前从未留意过的细节——她们之间的互动，似乎并不像表面上看起来那么简单……',
    content: `<p>李阿姨是母亲从初中就认识的好朋友，两人感情好得就像亲姐妹一样。每年夏天，李阿姨都会从另一个城市飞过来，在我家住上一周。</p>
<p>今年是我大学毕业的那个夏天。赋闲在家的我，第一次有了充足的时间观察她们之间的相处。</p>
<p>李阿姨比母亲小两岁，保养得很好。四十五岁的人了，看起来最多三十五六。她总是穿得很讲究，化着精致的淡妆，举手投足间透着一种成熟女性特有的魅力。</p>
<p>她们在一起的时候，总有一种奇特的氛围。那种感觉很难形容——就像是两个人在用一种只有彼此才懂的语言在交流。有时候她们坐在客厅里聊天，一句没头没尾的话就能让对方笑得前仰后合。有时候她们一起在厨房做饭，肩并肩地忙碌着，偶尔相视一笑，那笑容里有一种我说不清道不明的默契。</p>
<p>有一天晚上我睡不着，下楼倒水喝。客厅的灯已经关了，但阳台上有微弱的光透过来。我悄悄走过去，看到母亲和李阿姨坐在阳台的藤椅上，两个人挨得很近，低声说着什么。</p>
<p>月光下，母亲的头靠在李阿姨的肩膀上。李阿姨的手指轻轻梳理着母亲的头发，动作温柔得像在抚摸一件珍贵的瓷器。她们说话的声音很轻，我听不清内容，只看到母亲的肩膀微微颤抖着，像是在抽泣，又像是在笑。</p>
<p>那一幕安静而私密，仿佛是某个不应该被第三者看到的瞬间。我悄悄退回了自己的房间，心跳得厉害。我不知道自己为什么会有这样的反应——那明明只是两个亲密的朋友之间的普通互动。可是直觉告诉我，事情并不像表面看起来那么简单。</p>
<p>李阿姨走的那天，母亲在机场哭得泣不成声。回家的路上，车里的沉默压抑得让人喘不过气。我从后视镜里偷偷看母亲，她的眼睛红肿着，脸上是一种我从未见过的表情——那是一种混合着悲伤、失落和某种说不清的深情。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20wine%20glasses%20on%20a%20balcony%20railing%20under%20moonlight%2C%20city%20lights%20in%20the%20distance%2C%20intimate%20and%20romantic%20night%20atmosphere%2C%20dark%20cinematic%20photography%2C%20soft%20bokeh%20effect&width=800&height=500&seq=article-cover-6&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-30',
    readCount: 11234,
    tags: ['闺蜜', '秘密', '友情', '夏天'],
    featured: true,
  },
  {
    id: 'article-7',
    title: '出差途中的意外邂逅',
    excerpt: '那次去成都出差，本是一次再普通不过的商务旅行。却没有想到，在飞机上邻座的那个男人，会让我在接下来三天里经历一场前所未有的冒险……',
    content: `<p>飞机起飞的时候，我正手忙脚乱地翻找着耳机。旁边座位上传来一声轻笑，接着一只手伸过来，递给我一副白色的AirPods。</p>
<p>"用我的吧，正好有两副。"声音低沉而有磁性，带着一点川渝口音。</p>
<p>我转过头，第一次认真打量了邻座的男人。大概三十二三岁的年纪，穿着合身的深蓝色西装，袖口露出半截精瘦的手腕。他的眼睛很特别，是一种偏深的琥珀色，笑起来的时候眼尾微微上翘，像狐狸。</p>
<p>两个小时的航程，我们聊了很多。他叫周铭，在成都经营一家设计公司。这次是从上海谈完项目回程。他说话风趣幽默，总能在不经意间让人发笑。当我们降落在双流机场的时候，我已经觉得和他相识了很久。</p>
<p>他说加个微信吧，在成都如果有什么需要帮忙的可以找他。我犹豫了一下——我是一个已婚女人，加一个陌生男人的微信似乎不太合适。但最终我还是扫了他的二维码。我告诉自己这只是正常社交，可心里某个角落知道这不是真的。</p>
<p>第二天晚上，会议结束后我收到他的消息："成都的火锅比上海的正宗多了，不尝尝就走太可惜了。赏个脸？"</p>
<p>我盯着那条消息看了整整五分钟，手指在"好的"和"不了"之间反复悬停。最终，我回复了一个简单的"好"。</p>
<p>那顿火锅吃到了凌晨一点。他带我去的不是那些游客去的网红店，而是一家藏在老小区深处的苍蝇馆子。红油翻滚的锅底，鲜嫩爽脆的毛肚，还有他不停给我夹菜的那份细致体贴，都让我感到一种久违的被照顾的温暖。</p>
<p>吃完火锅，他说附近有一条河边步道，晚上散步很舒服。我没有拒绝。</p>
<p>河面上倒映着两岸的灯火，夜风带着湿润的水汽轻轻拂过。我们并排走着，肩膀偶尔碰在一起。不知从哪一刻开始，他的手不知道什么时候握住了我的。我没有抽开。</p>
<p>出差结束回到上海的那天，丈夫来机场接我。他问我成都怎么样，我说挺好的，火锅很好吃。没有更多了。</p>
<p>微信上周铭的消息还静静地躺在聊天列表里，我没有回复，也没有删除。那三天像一场短暂而绚烂的烟火，绽放过就够了。</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=Chengdu%20cityscape%20at%20night%20reflected%20on%20a%20river%2C%20warm%20city%20lights%2C%20romantic%20atmosphere%2C%20dark%20moody%20photography%2C%20intimate%20travel%20vibe&width=800&height=500&seq=article-cover-7&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-28',
    readCount: 8732,
    tags: ['出差', '邂逅', '旅行', '成都'],
    featured: false,
  },
  {
    id: 'article-8',
    title: '淫母日记：母亲的红色高跟鞋',
    excerpt: '那是我第一次对母亲产生异样的感觉。一双红色的高跟鞋，一条开叉的黑色长裙，还有镜子里她嘴角那一抹若有若无的神秘微笑……',
    content: `<p>每个周六晚上，父亲都会去和他的朋友们打麻将，通常要到凌晨才会回来。那些夜晚，家里就只有我和母亲两个人。</p>
<p>我记得很清楚，那天是七月十四号。天气热得不像话，即使开着空调，空气中也弥漫着一股黏腻的湿热。我躺在客厅沙发上百无聊赖地刷着手机，忽然听到卧室里传来母亲哼歌的声音。</p>
<p>卧室的门没有关严，露出一条缝。我鬼使神差地从沙发上起身，轻手轻脚地走了过去。</p>
<p>透过门缝，我看到母亲正站在落地镜前。她穿着一件我从没见过的黑色连衣裙，裙摆开叉到大腿中段，露出白皙修长的双腿。她的脚上踩着一双鲜艳的红色高跟鞋，鞋跟又细又高，让她整个人挺拔了起来，背脊挺得笔直。</p>
<p>她对着镜子缓缓转了一圈，裙摆在空气中划出一道优美的弧度。然后她停下来，侧过身，用一种我从没在母亲身上见过的姿态——一只手轻抚着自己的腰侧，另一只手将长发撩到一侧，露出白皙的脖颈。</p>
<p>她的嘴角挂着一抹若有若无的微笑。那不是一个母亲的微笑，甚至不是一个妻子的微笑。那是一个女人在欣赏自己的微笑——带着一点自恋，一点妩媚，还有一点神秘。</p>
<p>我感到喉咙发干，手心出汗。那是一种奇怪的、令人不安的感觉。站在门外的仿佛不再是我的母亲，而是一个我完全不认识的、充满魅力的陌生女人。</p>
<p>她似乎察觉到了什么，忽然转过头来。我们的目光在镜中相遇。那一瞬间，她的脸上闪过一丝慌乱，然后是尴尬，最后是一种我读不懂的复杂表情。</p>
<p>"小宇？你什么时候站在那里的？"她的声音有些不自然。</p>
<p>"我……我刚过来。妈，你要出去吗？"</p>
<p>她沉默了几秒，然后轻轻笑了一下。"不出去，就是想试试这双鞋。"</p>
<p>她转过身来，走到衣柜前，开始把裙子脱下来。但我注意到，她的动作不像平时那么自然。她有意无意地侧着身体，像是在回避我的目光。</p>
<p>那晚我躺在床上久久无法入睡。脑海中反复浮现出母亲穿着红色高跟鞋的样子。那抹红色像烙印一样刻在了我的记忆里，怎么也抹不去。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20red%20high%20heels%20on%20a%20dark%20floor%20with%20soft%20lighting%2C%20sensual%20and%20mysterious%20atmosphere%2C%20dark%20elegant%20photography%2C%20intimate%20mood%2C%20warm%20shadows&width=800&height=500&seq=article-cover-8&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-25',
    readCount: 18976,
    tags: ['高跟鞋', '母亲', '秘密', '夜晚'],
    featured: true,
  },
  {
    id: 'article-9',
    title: '图书馆里的对视',
    excerpt: '考研的最后三个月，我几乎每天都泡在图书馆里。直到有一天，我发现对面的桌子多了一个人。一次不经意的对视，让原本枯燥的备考生活变得不再平静……',
    content: `<p>考研的最后三个月是最难熬的。每天在图书馆从早坐到晚，面前堆着看不完的专业书和做不完的真题。有时候盯着那些密密麻麻的文字，我觉得自己的大脑快要宕机了。</p>
<p>图书馆四楼的角落是我固定坐的位置。靠窗，安静，阳光好。我习惯了这里的一切——窗外那棵梧桐树随着季节变化的样子，暖气片发出轻微的嗒嗒声，还有浓厚的书卷气。</p>
<p>十月初的一个上午，对面那张空了很久的桌子终于迎来了它的新主人。我抬头看了一眼——是一个女生，穿着一件米白色的针织衫，头发松松地扎成低马尾，露出一截白皙的脖颈。</p>
<p>起初我没太在意。毕竟图书馆里人来人往，座位换来换去很正常。但三天后，我发现她似乎也把这个位置当成了她的固定座位。</p>
<p>我们面对面坐着，中间隔着一张宽大的木桌。每天十几个小时，我们几乎没有任何交流，却形成了一种奇特的默契。她会在我打瞌睡的时候轻轻敲一下桌子，我会在她找不到电源插座的时候默默把自己的排插推过去。</p>
<p>直到有一天下午，我学累了，抬起头活动脖子，正好对上了她的目光。她也恰好在这个时候抬起了头。我们的视线在半空中撞在了一起。</p>
<p>那一瞬间，我感觉时间仿佛凝固了。她的眼睛很漂亮，瞳孔是浅浅的棕色，里面倒映着窗外梧桐树的影子。我们对视了大概三秒钟——也许更久——然后同时移开了目光。</p>
<p>我的脸颊有点发烫，心跳快了几拍。我假装继续看书，但那些字一个也看不进去了。余光中，我看到她也在用手指心不在焉地翻着书页，耳根处隐约泛着粉色。</p>
<p>从那天起，一切都不一样了。我们的对视越来越频繁，从一开始的偶然变成了一种心照不宣的习惯。每次抬头，总能发现对方也在看着自己。那是一种奇妙的感觉——好像整个图书馆里只剩下了我们两个人。</p>
<p>考研结束的那天，我从考场出来，在校门口看到了她。她站在梧桐树下，手里拿着两杯奶茶。看到我，她笑了一下，把其中一杯递过来。</p>
<p>"考得怎么样？"她问。</p>
<p>"还行吧。你呢？"</p>
<p>"也还行。"</p>
<p>我们就这样站在夕阳下喝着奶茶，聊着一些无关紧要的话题。谁也没有提起图书馆里那些漫长的对视，但那些时刻，已经是我们之间最珍贵的秘密。</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20quiet%20library%20with%20sunlight%20streaming%20through%20large%20windows%2C%20books%20on%20wooden%20tables%2C%20warm%20and%20peaceful%20atmosphere%2C%20dark%20academic%20vibe%2C%20intimate%20indoor%20scene&width=800&height=500&seq=article-cover-9&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-22',
    readCount: 5678,
    tags: ['图书馆', '校园', '对视', '考研'],
    featured: false,
  },
  {
    id: 'article-10',
    title: '淫母日记：浴室里的歌声',
    excerpt: '母亲有一个习惯——每次洗澡的时候都会唱歌。那些老歌从浴室里飘出来，带着水汽和香皂的味道，变成了我童年最深刻的记忆之一。直到有一天，我终于听懂了歌词里的秘密……',
    content: `<p>从我记事起，母亲洗澡时就会唱歌。不是那种大声的、跑调的随便哼哼，而是真正动听的、婉转悠扬的歌声。她的声音很好听，有一种沙沙的质感，像旧唱片里放出来的老歌。</p>
<p>小的时候，我会搬个小凳子坐在浴室门外，听母亲唱歌。她唱的大多是八九十年代的流行歌曲——《月亮代表我的心》《何日君再来》《恰似你的温柔》。那时候我不懂歌词是什么意思，只觉得那些旋律温柔又好听，像是能把人带到一个很远很远的地方。</p>
<p>随着年龄的增长，这个习惯渐渐被我淡忘了。直到上个月，我从外地回来休假，深夜经过母亲的房门口，又听到了浴室里传来的歌声。</p>
<p>那天她唱的是邓丽君的《我只在乎你》。"如果没有遇见你，我将会是在哪里，日子过得怎么样，人生是否要珍惜……"</p>
<p>她的声音一如既往地温柔，但我第一次听出了一些不一样的东西。那旋律里有一种深深的、挥之不去的忧伤，像是一滴墨水滴进了清水里，无声无息地扩散开来。</p>
<p>我站在门外听了很久。母亲唱完一首，接着又唱了《千言万语》。"不知道为了什么，忧愁它围绕着我……"</p>
<p>歌声和水声混在一起，隔着门板，听起来有些朦胧。但那种忧伤却清晰得触手可及。那一瞬间，我忽然明白了——母亲唱的每一首歌，都是在唱给某个人听的。一个我不认识、也可能永远不会认识的人。</p>
<p>那些歌是她无法说出口的思念，是她藏在心底最深处的秘密。而浴室里的水声和歌声，是她唯一能够释放这些情绪的方式。</p>
<p>水声停了。厕所门打开，母亲穿着浴袍走出来，头发还湿漉漉的。看到我站在门外，她愣了一下。</p>
<p>"怎么还不睡？"</p>
<p>"妈，你唱歌真好听。"</p>
<p>她笑了，那个笑容里有惊喜，也有一点点不好意思。"老歌了，瞎唱唱。"</p>
<p>她转身进了卧室，留下我一个人站在走廊里。空气中还残留着沐浴露的香味和若有若无的歌声。那一刻我无比确定——母亲的心里住着一个我从未真正了解过的女人。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=Steam%20on%20a%20bathroom%20mirror%20with%20soft%20warm%20lighting%2C%20water%20droplets%2C%20intimate%20and%20moody%20atmosphere%2C%20dark%20sensual%20photography%2C%20warm%20amber%20glow&width=800&height=500&seq=article-cover-10&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-20',
    readCount: 14209,
    tags: ['歌声', '浴室', '回忆', '母亲'],
    featured: true,
  },
  {
    id: 'article-11',
    title: '午夜出租车的女司机',
    excerpt: '那天晚上从酒吧出来，我叫了一辆网约车。来接我的是一个三十多岁的女司机。一个小时的夜路，她给我讲了一个让我至今难忘的故事……',
    content: `<p>凌晨两点，我从酒吧出来，叫了一辆网约车。不到三分钟，一辆白色的电动车悄无声息地停在了我面前。</p>
<p>车窗摇下来，露出一张三十多岁的女人面孔。她的五官端正，眉眼间有一种说不上来的风情。她穿着一件紧身的黑色T恤，头发随意地扎成马尾。</p>
<p>"尾号4848？"她的声音比我想象中要低一些，带着一点沙哑的磁性。</p>
<p>我上了车。车厢里很干净，有一股淡淡的栀子花香。后排座位上放着一只旧旧的小熊玩偶，看起来和这个干练的女司机有些格格不入。</p>
<p>夜路漫长，我们有一搭没一搭地聊了起来。她叫苏姐，开网约车已经三年了。之前做过很多事情——销售、行政、甚至还开过一家小花店。</p>
<p>"那为什么后来不开了？"我问。</p>
<p>她从后视镜里看了我一眼，笑了笑。那个笑容很淡，但车窗外路灯的光恰好打在脸上，让她整个人忽然变得很有故事感。</p>
<p>"因为一个人。"她说。</p>
<p>我没有追问，但她自己接着说了下去。那个花店是她和一个男人一起开的。那个男人比她大十二岁，已婚，有两个孩子。他们在一起三年，花店是他们的秘密基地。</p>
<p>"你知道吗，那种感觉很奇怪。"她说，"明明知道他是错的，明明知道没有结果，但就是放不下。每次看到他来店里，捧着一束花站在门口笑的样子，我就觉得一切都不重要了。"</p>
<p>后来那个男人的妻子发现了。一场闹剧之后，男人回归了家庭，她关掉了花店，一个人来到这座城市重新开始。</p>
<p>"这三年里，我拉过很多深夜的乘客。"苏姐说，"有喝醉的，有哭的，有在车里打电话吵架的。每个人都有自己的故事，就像每个人都有自己放不下的人。"</p>
<p>车停在我家楼下时，计价器上显示着一个半小时的车程。实际上只要四十分钟，是她绕了远路——我们都心知肚明，谁也没有说破。</p>
<p>"再见。"她说。</p>
<p>"再见，苏姐。"</p>
<p>白色电动车消失在夜色中。我站在楼下抽了一根烟，脑海里一直在回想她的故事。这座城市那么大，每个人都藏着自己的秘密，像一颗颗散落在黑夜里的星星。</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20city%20street%20at%20night%20seen%20through%20a%20car%20window%20with%20rain%20droplets%2C%20neon%20lights%20reflecting%2C%20moody%20and%20melancholic%20night%20atmosphere%2C%20dark%20cinematic%20photography&width=800&height=500&seq=article-cover-11&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-18',
    readCount: 4890,
    tags: ['出租车', '夜晚', '故事', '都市'],
    featured: false,
  },
  {
    id: 'article-12',
    title: '淫母日记：厨房里的午后',
    excerpt: '母亲在厨房里的背影，是我记忆中最熟悉的画面之一。围裙的带子在腰间系成一个蝴蝶结，手里的锅铲上下翻飞，空气中弥漫着饭菜的香气。直到那个午后，我才发现这个场景也可以变得完全不同……',
    content: `<p>母亲的厨艺是出了名的好。左邻右舍谁家做了好吃的，都会端一盘来让我们尝尝，但无一例外都会被母亲的手艺比下去。红烧肉要肥而不腻，清蒸鱼要鲜嫩滑口，哪怕是简单的一道西红柿炒鸡蛋，她都能做得比别人香。</p>
<p>我喜欢坐在厨房门口的高脚凳上，看着母亲忙碌的背影。围裙带子在腰间系成一个蝴蝶结，随着她切菜的动作轻轻晃动。阳光从窗户斜斜地照进来，给她的轮廓镀上一层金色的光晕。</p>
<p>那是再普通不过的一个午后。母亲在厨房里揉面，准备晚上包饺子。我照例坐在门口，手里拿着一本书，但根本看不进去——所有的注意力都在母亲身上。</p>
<p>那天她穿着一件淡蓝色的家居裙，质地轻薄柔软。阳光穿透布料，隐约勾勒出身体的曲线。她弯着腰揉面的时候，领口微微敞开，露出锁骨下面一小片白皙的皮肤。</p>
<p>我忽然感到一种难以名状的燥热。那是一种从来没有过的感觉——心跳加速，喉咙发干，视线像被磁铁吸住了一样，怎么也移不开。</p>
<p>母亲似乎察觉到了什么，转头看了我一眼。"看什么呢？来帮我把围裙重新系一下，带子松了。"</p>
<p>我放下书，走到她身后。围裙的带子确实松了，蝴蝶结变成了一个快要散开的单结。我伸出手，手指碰到了她腰间的布料——很薄，我能感觉到下面皮肤的温度。</p>
<p>那一瞬间，整个厨房仿佛忽然缩小了。我能听到自己的呼吸声，还有母亲的呼吸声——比刚才更轻，更慢，像是刻意压制着什么。</p>
<p>"好了吗？"她的声音有些不自然。</p>
<p>"快了。"我的声音也变哑了。</p>
<p>手指笨拙地打了一个新结之后，我迅速退回到了高脚凳上。母亲继续揉面，动作比之前更用力，更快。我们谁也没有说话，厨房里只剩下揉面团的窸窣声响。</p>
<p>窗外的阳光依旧明亮，但厨房里的气氛已经完全变了。那个再熟悉不过的场景，从那个午后开始，在我心里有了完全不同的意义。而我隐隐约约地感觉到，对母亲来说，也是一样。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=Sunlight%20streaming%20into%20a%20warm%20kitchen%2C%20flour%20dust%20floating%20in%20the%20air%2C%20intimate%20afternoon%20atmosphere%2C%20homey%20yet%20sensual%20mood%2C%20dark%20warm%20photography&width=800&height=500&seq=article-cover-12&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-15',
    readCount: 20145,
    tags: ['厨房', '午后', '母亲', '回忆'],
    featured: true,
  },
  {
    id: 'article-13',
    title: '合租室友的深夜敲门',
    excerpt: '毕业后来到这座陌生城市，为了省钱选择与人合租。室友是一个看起来很普通的女孩，安静、整洁、有礼貌。直到某个深夜，她敲开了我的房门……',
    content: `<p>毕业后来到这座陌生的城市，我租了一套两室一厅的老房子，和一个女孩合租。</p>
<p>她叫安然，是一个看起来很普通的女孩。短发，素颜，总是穿着宽松的卫衣和牛仔裤。她在一家出版社做编辑，每天朝九晚五，生活规律得像一本日历。我们相处得还不错——她安静，我话少，各自关在房间里，互不打扰。</p>
<p>这种平静的生活持续了大概四个月。直到那个深夜。</p>
<p>那天是周五，我加完班回到家已经快十一点了。洗完澡准备睡觉的时候，忽然听到有人敲门。打开门，是安然。她穿着睡衣，头发湿漉漉的，手里拿着一瓶红酒和两个杯子。</p>
<p>"睡不着，想找人喝一杯。打扰你吗？"她的声音比平时更低沉一些。</p>
<p>我愣了一下，还是让她进来了。我们在我的房间里席地而坐，靠着床边，有一口没一口地喝着酒。窗外偶尔有车辆驶过，车灯在天花板上划过一道光，又迅速消失。</p>
<p>安然平时话不多，但那天晚上像是打开了某个开关。她说了很多——关于她的童年，她的前任，她来到这个城市的原因。红酒让她的脸颊泛起了红晕，也让她的眼神变得迷离而柔软。</p>
<p>说到动情处，她的眼睛里泛起了泪光。我不知道该怎么安慰她，只是轻轻拍了拍她的肩膀。她的手忽然覆上了我的手，手心温热。</p>
<p>我转过头，发现她离我很近——近到能闻到她头发上洗发水的香味，近到能在她眼睛里看到自己的倒影。房间里的空气仿佛凝固了。</p>
<p>然后她靠了过来。轻轻的，像一片羽毛落在水面上。</p>
<p>那个夜晚改变了一切。我们不再是普通的合租室友了，但也没有成为情侣。我们小心翼翼地维持着一种微妙的平衡——在外人面前，我们只是普通的室友；关上门后，我们是彼此的秘密。</p>
<p>这种关系持续了半年，直到她因为工作调动搬去了另一个城市。走的那天，她在我房门口放了一瓶红酒，和一张纸条，上面写着："谢谢你，让我不再那么孤独。"</p>`,
    category: '短篇故事',
    categorySlug: 'short-stories',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20bedroom%20with%20a%20bottle%20of%20red%20wine%20and%20two%20glasses%20on%20the%20floor%2C%20dim%20warm%20lighting%2C%20intimate%20late%20night%20atmosphere%2C%20dark%20moody%20photography&width=800&height=500&seq=article-cover-13&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-12',
    readCount: 7234,
    tags: ['合租', '深夜', '孤独', '都市'],
    featured: false,
  },
  {
    id: 'article-14',
    title: '淫母日记：梦境与现实之间',
    excerpt: '最近总是做一个相同的梦。梦里的母亲穿着年轻时的碎花裙子，站在老家的院子里冲我微笑。但当我走近，她的脸开始变化，变成了一个我既熟悉又陌生的女人……',
    content: `<p>最近总是做一个相同的梦。梦里是二十年前的老家——红砖墙，青瓦顶，院子里那棵石榴树正开着火红的花。母亲站在树下，穿着那件我记忆中最熟悉的碎花连衣裙，头发没有像平时那样盘起来，而是披散在肩上，被风吹得轻轻飘动。</p>
<p>她冲我微笑，招手让我过去。我朝她走去，但每走一步，院子就变长一点，我和她之间的距离始终没有缩短。她的脸在阳光下忽明忽暗，时而是我熟悉的母亲的温柔面容，时而又变成了一个陌生的、充满诱惑的表情。</p>
<p>当我终于快要走到她面前的时候，母亲忽然开口说话了。她说的每一个字都很轻柔，但那些话的内容却让我面红耳赤——那不是母亲会对孩子说的话。</p>
<p>然后我就醒了。浑身是汗，心跳如擂鼓，感觉自己像是犯了一个不可饶恕的罪。</p>
<p>白天的时候，我会忍不住偷偷观察母亲。她穿着普通的家居服，在客厅里织毛衣，或者给窗台上的盆栽浇水。一切都很正常，和梦里那个身穿碎花裙、说着暧昧话语的女人判若两人。</p>
<p>但我知道那不是真的"正常"。有什么东西已经在我心里发生了改变，像是一颗深埋地下的种子，在黑暗和温暖中悄悄发芽。我看母亲的眼神不再像以前那样纯粹——那里面掺杂了太多复杂的东西，有愧疚，有困惑，还有一种连我自己都不愿意承认的悸动。</p>
<p>昨晚的梦里，母亲的碎花裙子变成了红色。那颜色鲜艳得像血，又像即将熄灭的落日余晖。她不再站在远处，而是站在我面前，近到我能感觉到她的呼吸。她伸出手，冰凉的指尖轻触我的脸颊，然后她说话了——</p>
<p>这一次，我没有逃跑。我在梦里选择了留下。</p>
<p>醒来的时候，枕头湿了一大片。我不知道那是汗，还是梦里流下的眼泪。但我知道，昨天晚上的那个梦，改变了一切。</p>`,
    category: '日记系列',
    categorySlug: 'diary-series',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dreamy%20pomegranate%20tree%20in%20a%20courtyard%20with%20soft%20sunlight%2C%20ethereal%20and%20surreal%20atmosphere%2C%20hazy%20dreamlike%20quality%2C%20dark%20warm%20photography%2C%20nostalgic%20mood&width=800&height=500&seq=article-cover-14&orientation=landscape',
    author: '匿名作者',
    date: '2026-07-10',
    readCount: 16543,
    tags: ['梦境', '回忆', '母亲', '变化'],
    featured: true,
  },
  {
    id: 'article-15',
    title: '连载：错爱（第一章）',
    excerpt: '我叫林小雨，今年二十八岁，在一家广告公司做文案策划。结婚三年，有一个两岁的女儿。在外人眼里，我有一个完美的家庭。但只有我自己知道，这段婚姻早已千疮百孔……',
    content: `<p>我叫林小雨，今年二十八岁，在一家广告公司做文案策划。老公叫陈默，在一家IT公司做技术总监。我们结婚三年，有一个两岁的女儿叫小丸子。在外人眼里，我们的家庭堪称完美——有房有车，夫妻恩爱，孩子可爱。</p>
<p>但只有我知道，这段婚姻的裂痕早已出现，只是一直被表面的平静掩盖着。</p>
<p>陈默是个好人，这一点我从来没有怀疑过。他从不乱花钱，从不和别的女人暧昧，周末会主动带孩子。但问题恰恰出在这里——他太好了，好到和我之间没有任何激情可言。我们之间的对话只剩下"今天谁接孩子""晚上吃什么""物业费该交了"这些重复了一万遍的琐事。</p>
<p>有时候我洗完澡从浴室出来，裹着浴巾，故意在他面前多晃一会儿。他却只是盯着电脑屏幕，头也不回地说一句："别着凉了，快去穿衣服。"</p>
<p>那种感觉，就像一拳打在了棉花上。</p>
<p>直到那天，我在客户提案的会议上遇到了陆铭。</p>
<p>陆铭是我们正在对接的那家品牌方的市场总监。三十出头，气质干练，说话时总是带着一种让人舒服的从容。第一次见面是在他们的会议室里，我做完了两个小时的提案，口干舌燥，他递给我一瓶矿泉水，瓶盖是已经拧开的。</p>
<p>这个细节触动了我。陈默已经很久没有为我拧开过一个瓶盖了。</p>
<p>后来的合作越来越频繁。我们开始单独吃饭，从午餐到晚餐，从晚餐到深夜的咖啡。他从不越界，但他的每一个眼神、每一句话、每一个不经意的触碰，都像一根火柴，在我干涸的心里擦出火花。</p>
<p>我知道自己在玩火。我有家庭，有孩子，有一个还算过得去的丈夫。可是那种被关注、被理解、被当作一个女人而不是一个妻子或母亲来看待的感觉，太让人上瘾了。</p>
<p>上周五，陆铭送我到小区门口。下车之前，他的手握住了我的手腕。那个动作很轻，像蝴蝶停在花瓣上，但带来的震颤却传遍了我全身。</p>
<p>"小雨，"他说，声音低沉而温柔，"你值得更好的。"</p>
<p>我没有回答。我挣脱了他的手，逃也似的跑进了小区。电梯里，我看着镜子里的自己——脸颊绯红，眼神慌乱，胸口起伏不定——像一个十八岁第一次约会的少女。</p>
<p>回到家，陈默正坐在沙发上看电视。小丸子已经睡了。他看到我，只是问了一句："今天怎么回来这么晚？"</p>
<p>"加班。"我低着头走进卧室，怕他看到我脸上的表情。</p>
<p>躺在床上，我久久无法入睡。陆铭的话一遍又一遍地在我脑海中回响。我值得更好的。我值得更好的。我值得更好的。</p>
<p>可是"更好"的代价是什么？我不知道。我只知道，站在悬崖边上的感觉，既让人恐惧，又让人无比兴奋。</p>
<p>（第一章完，待续）</p>`,
    category: '连载小说',
    categorySlug: 'serial-novels',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20woman%20looking%20out%20of%20a%20rainy%20window%20at%20night%2C%20city%20lights%20reflected%2C%20melancholic%20and%20contemplative%20mood%2C%20dark%20cinematic%20portrait%20style%2C%20sensual%20atmosphere&width=800&height=500&seq=article-cover-15&orientation=landscape',
    author: '匿名作者',
    date: '2026-08-11',
    readCount: 25431,
    tags: ['连载', '婚姻', '诱惑', '都市'],
    featured: true,
  },
];

export const aboutData = {
  brandIntro: `淫母日记创立于2020年，是国内领先的成人日记文学阅读平台。我们致力于为成年读者提供高质量的原创日记文学作品，涵盖日记系列、短篇故事、连载小说等多种类型。

我们的编辑团队由资深文学从业者组成，严格把控每一篇作品的质量。我们相信，好的成人文学作品不仅仅是感官刺激，更是对人性深处的探索与表达。每一个故事都是一个世界，每一个人物都承载着复杂的情感和欲望。

三年来，淫母日记已经发展成为拥有超过百万注册用户的知名平台，每日更新数十篇优质原创内容。我们的作者来自全国各地，他们用文字描绘着各自独特的故事，为读者打开一扇扇通往不同世界的大门。`,
  reputation: [
    { name: '读者·李明', comment: '在这里读到了很多打动我的故事。文笔优美，情节引人入胜，每天睡前都会来看看有没有更新。强烈推荐！', rating: 5 },
    { name: '读者·王芳', comment: '很喜欢日记系列，每一篇都让人感同身受。文字细腻，情感真挚，不是那种低俗的色情内容，而是真正的文学作品。', rating: 5 },
    { name: '读者·张伟', comment: '朋友推荐来的，一开始只是好奇，结果一看就停不下来了。连载小说《错爱》写得特别好，每天追更中！', rating: 4 },
    { name: '读者·陈静', comment: '作为一个文学爱好者，我觉得这个平台的文学品质超出预期。很多短篇故事甚至可以和传统文学杂志上的作品媲美。', rating: 5 },
    { name: '读者·刘洋', comment: '界面简洁干净，阅读体验很好。最重要的是内容质量一直很稳定，不会像有些平台一样充斥着低质量的灌水文章。', rating: 4 },
    { name: '读者·赵雪', comment: '每晚睡前必看的网站，很多文章都反复读过好几遍。有些句子甚至会摘抄下来，真的很打动人。', rating: 5 },
  ],
  contact: {
    email: 'contact@elinggong.cn',
    wechat: 'yinfumuji_official',
    qq: '1234567890',
    address: '中国上海市浦东新区张江高科技园区',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};